import React, { FC, useEffect, useState } from "react";
import MainNav2Logged from "./MainNav2Logged";
import TopHeader from "./TopHeader";
import axios from "axios";
import api from "constants/api";

export interface HeaderLoggedProps { }

const HeaderLogged: FC<HeaderLoggedProps> = () => {
  const [specialMessage, setSpecialMessage] = useState<{ content: string; hyperlink?: string, colour_code?: string, font_style?: string } | null>(null);

  useEffect(() => {
    if (specialMessage?.font_style) {
      const linkId = 'dynamic-font-link';
      let link = document.getElementById(linkId) as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }
      link.href = `https://fonts.googleapis.com/css2?family=${specialMessage.font_style.replace(/ /g, '+')}&display=swap`;
    }
  }, [specialMessage?.font_style]);

  useEffect(() => {
    const fetchSpecialMessages = async () => {
      try {
        const url = process.env.REACT_APP_API_URL + api.getSpecialMessageList;
        const response = await axios.post(url, {});
        const result = response.data?.data?.result || [];
        const activeMsg = result.find((msg: any) => msg.status === "Active");
        if (activeMsg) {
          setSpecialMessage({
            content: activeMsg.content,
            hyperlink: activeMsg.hyperlink,
            colour_code: activeMsg.colour_code,
            font_style: activeMsg.font_style
          });
        }
      } catch (error) {
        // Optionally handle error
      }
    };
    fetchSpecialMessages();
  }, []);

  return (
    <>
      {/* SPECIAL MESSAGE BANNER */}
      {specialMessage && (
        <div
          style={{
            background: "#eff6ff",
            color: specialMessage.colour_code || "#0F172A",
            fontFamily: specialMessage.font_style || "inherit",
            padding: "8px 0",
            textAlign: "center",
          }}
          className="sticky top-0 left-0 w-full z-50"
        >
          {specialMessage.hyperlink ? (
            <a
              href={specialMessage.hyperlink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline" }}
            >
              {specialMessage.content}
            </a>
          ) : (
            <span>{specialMessage.content}</span>
          )}
        </div>
      )}

      {/* HEADER (pushed down if banner is present) */}
      <div
        className="nc-HeaderLogged sticky w-full z-40"
        style={{ top: specialMessage ? 40 : 0 }} // 48px = 8px padding + font size + line height
      >
        {/* <TopHeader /> */}
        <MainNav2Logged />
      </div>
    </>
  );
};

export default HeaderLogged;